export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const UPDATE_PROJECT_ID = 'UPDATE_PROJECT_ID'
export const UPDATE_PROJECT_NAME = 'UPDATE_PROJECT_NAME'
export const UPDATE_PROJECT_LOCATION = 'UPDATE_PROJECT_LOCATION'
export const UPDATE_PROJECT_DETAIL = 'UPDATE_PROJECT_DETAIL'
export const UPDATE_DESIGN_NAME = 'UPDATE_DESIGN_NAME'
export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const UPDATE_AUTH_DATA = 'UPDATE_AUTH_DATA'



// WEBPACK FOOTER //
// ./src/store/mutation_types.js